module.exports = __webpack_public_path__ + "img/muito-ruim.a2d8115a.png";